module.exports = __webpack_public_path__ + "img/404.f95f392f.png";